<template>
  <a class="btn btn-primary" @click="cacheStaticSearches" :disabled="disabled">
    <i class="mdi mdi-reload"></i>
    Selecties opnieuw laden
  </a>
</template>

<script>
import staticSearchApi from '~/api/staticSearch';

export default {
  name: "CacheStaticSearchesButtonComponent",
  data() {
    return {
      disabled: false,
    }
  },
  methods: {
    cacheStaticSearches() {
      this.disabled = true;
      staticSearchApi.flushCache().then(response => {
        window.location.reload();
      }).finally(() => {
        this.disabled = false;
      });
    }
  }
}
</script>